import { useForm } from "react-hook-form";
import { EmptyPlaceholderText } from "../../dynamicForm/inlineForm/EmptyPlaceholderText";
import { useTranslation } from "@privacy/translations";
import { useMutation } from "@tanstack/react-query";
import { DynamicForm } from "../../dynamicForm";
import { ErrorMessage } from "../../dynamicForm/inlineForm/ErrorMessage";
import { DynamicShared } from "../../dynamicShared";
import { updateDpiaMutationOptions } from "../../api/dpia";
import { ExternalLinkIcon } from "../../shared/icons";
import type { DpiaById } from "../../api/dpia.types";

export const DpiaUrlField = ({ dpia, isReadOnly }: { dpia: DpiaById; isReadOnly: boolean }) => {
  const { t } = useTranslation();
  const updateDpiaMutation = useMutation(updateDpiaMutationOptions());
  const form = useForm({ values: { url: dpia.url ?? "" } });

  return (
    <DynamicForm.InlineFieldPrimary
      htmlFor="url"
      label={t("DpiaDrawer.Url.Label")}
      input={
        <DynamicForm.StyledInlineTextInput
          id="url"
          form={form}
          numberOfRows={1}
          isReadOnly={isReadOnly}
          Icon={ExternalLinkIcon}
          validation={{ validator: value => value.trim() !== "" }}
          onSave={value => updateDpiaMutation.mutateAsync({ id: dpia.id, payload: { url: value } })}
          renderNonEditingInputContent={value =>
            value ? (
              <DynamicShared.ExternalLink href={value}>{value}</DynamicShared.ExternalLink>
            ) : (
              <EmptyPlaceholderText />
            )
          }
          renderErrorMessage={({ isValidationError, isSaving, isSaveError }) => (
            <>
              {isValidationError && <ErrorMessage errorMessage={t("CreateDpia.Dialog.UrlError")} />}
              {!isSaving && isSaveError && <ErrorMessage />}
            </>
          )}
        />
      }
    />
  );
};
